import React from 'react';
import i18next from 'i18next';
import { Card, CardBody } from 'reactstrap';
import Currency from './../shared/currency';
import UtilsService from './../../services/utils/utils.service';

export default class HoldingInstrumentDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    render() {
        if (!this.props.detail) {
            return null;
        }
        
        return (
            <React.Fragment>
                <a className="d-flex align-items-center cursor-pointer text-bold mb-0" onClick={() => this.props.back()}>
                    <i className="fa fa-chevron-left"></i> {i18next.t('BACK')}
                </a>

                <br /><br />

                <Card className="border shadow mb-3">
                    <div className="p-1 border-bottom" style={{ borderTop: '2px solid #2977a7' }}>
                    <div className="d-flex flex-column">
                            <div className="d-flex align-items-center text-bold mb-0">
                                {this.props.detail.instrument}
                            </div>
                            <div className="d-flex align-items-center mb-0">
                                <span className='text-muted font-size-11 font-italic'>
                                    {i18next.t('ACCOUNT')}: {this.props.detail.account.displayText}
                                </span>
                            </div>
                        </div>
                    </div>
                    <CardBody className="p-2">
                        <div className="table-responsive" style={{ marginBottom: '-1rem' }}>
                            <table className="table table-sm border table-instruments">
                                <thead>
                                    <tr className="font-italic">
                                        <th>{i18next.t('INSTRUMENT')}</th>
                                        <th className="text-right">{i18next.t('QUANTITY')}</th>
                                        <th className="text-right">{i18next.t('UNIT')}</th>
                                        <th className="text-right">{i18next.t('PRICE')}</th>
                                        <th className="text-right">{i18next.t('SETTLEMENT')}</th>
                                        <th className="text-right">{i18next.t('DIFFERENCE')}</th>
                                        <th className="text-right">{i18next.t('CURRENCY_SYMBOL')}</th>
                                        <th className="text-right">{i18next.t('DATE')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { this.props.detail.contracts.map((item, index) => 
                                        <React.Fragment key={index}>
                                            <tr>
                                                <td>
                                                    { item.contract || '-' }
                                                </td>
                                                <td className="text-right">
                                                    { item.quantity ? <Currency amount={item.quantity} symbol={false} /> : '-' }
                                                </td>
                                                <td className="text-right">
                                                    { item.unitOfMeasurement ? UtilsService.translateUnitOfMeasurement(item.unitOfMeasurement) : '-' }
                                                </td>
                                                <td className="text-right">
                                                    { item.price ? <Currency amount={item.price} /> : '-' }
                                                </td>
                                                <td className="text-right">
                                                    { item.settlementPrice ? <Currency amount={item.settlementPrice} /> : '-' }
                                                </td>
                                                <td className={"text-right " + (item.dailySettlement < 0 ? 'text-danger': '')}>
                                                    <Currency amount={item.dailySettlement} symbol={false} />
                                                </td>
                                                <td className="text-right">
                                                    {UtilsService.translateCurrencySymbol(item.currency)}
                                                </td>
                                                <td className="text-right">
                                                    { item.clearingBusinessDate ? new Date(item.clearingBusinessDate).toLocaleDateString() : '-' }
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </React.Fragment>        
        );
    }
}